import { Link } from 'react-router-dom';
import SectionHeading from '@/components/feature/SectionHeading';
import { formatCount, getCategoryName, getPopularResources } from '@/lib/catalog';

const RANK_STYLES = [
  'bg-accent-500 text-background-50',
  'bg-accent-300 text-foreground-950',
  'bg-secondary-400 text-background-50',
];

export default function PopularResources() {
  const resources = getPopularResources(5);

  return (
    <section className="w-full px-4 md:px-8 py-14">
      <SectionHeading
        title="热门资源推荐"
        description="按点击热度排行，看看大家都在看什么。"
        icon="ri-fire-line"
      />
      <div className="flex flex-col gap-3">
        {resources.map((resource, index) => (
          <Link
            key={resource.id}
            to={`/detail/${resource.id}`}
            className="group flex items-center gap-4 p-3 md:p-4 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
          >
            <span
              className={`shrink-0 w-8 h-8 rounded-md font-heading font-bold text-sm flex items-center justify-center ${
                RANK_STYLES[index] || 'bg-background-200 text-foreground-700'
              }`}
            >
              {index + 1}
            </span>
            <div className="shrink-0 w-24 sm:w-32 h-16 sm:h-20 rounded-md overflow-hidden bg-background-200">
              <img
                src={resource.cover}
                alt={`${resource.title} - 热门资源`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2">
                <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900 text-xs">
                  {getCategoryName(resource.category)}
                </span>
                {resource.duration && (
                  <span className="text-xs text-foreground-500">{resource.duration}</span>
                )}
              </div>
              <h3 className="mt-1.5 font-heading font-semibold text-sm md:text-base text-foreground-950 line-clamp-1 group-hover:text-primary-700 transition-colors">
                {resource.title}
              </h3>
              <p className="hidden sm:block mt-1 text-sm text-foreground-600 line-clamp-1">
                {resource.summary}
              </p>
            </div>
            <div className="hidden md:flex flex-col items-end shrink-0 text-xs text-foreground-500">
              <span className="flex items-center gap-1 text-accent-700 font-medium">
                <i className="ri-eye-line"></i>
                {formatCount(resource.views)}
              </span>
              <span className="mt-1 flex items-center gap-1">
                <i className="ri-heart-line"></i>
                {formatCount(resource.favorites)}
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}